// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import {
  PrefillContactSource,
  PrefillContactEntityMode
} from './../../../types/next/blocks/contactBlock'
import {
  iBlockSchema,
  blockBaseSettingsSchema,
  iBlockFieldSchema
} from './baseBlock.zod'
import { referenceIdSchema } from './ids.zod'
import { blockReferenceSchema } from './references.zod'

export const presetChoiceFieldSchema = iBlockFieldSchema.extend({
  options: z.array(z.string()).optional()
})

export const prefillContactSourceSchema = z.nativeEnum(PrefillContactSource)

export const prefillContactEntityModeSchema = z.nativeEnum(
  PrefillContactEntityMode
)

export const prefillContactSettingsSchema = z.object({
  source: prefillContactSourceSchema,
  mode: prefillContactEntityModeSchema
})

export const contactBlockReferenceSchema = blockReferenceSchema.extend({
  meaning: z.string()
})

export const contactBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.CONTACT),
  settings: blockBaseSettingsSchema.and(
    z.object({
      purpose: z.array(z.string()),
      prefillSettings: prefillContactSettingsSchema.optional(),
      fields: z.object({
        salutation: presetChoiceFieldSchema,
        title: iBlockFieldSchema,
        firstName: iBlockFieldSchema,
        lastName: iBlockFieldSchema,
        email: iBlockFieldSchema,
        telephone: iBlockFieldSchema,
        birthDate: iBlockFieldSchema
      })
    })
  ),
  references: z.record(referenceIdSchema, contactBlockReferenceSchema)
})

export const contactBlockValueSchema = z.object({
  salutation: z.string().optional(),
  title: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  birthDate: z.union([z.date(), z.string()]).optional(),
  email: z.string().optional(),
  telephone: z.string().optional()
})
